import React from 'react';
import './Header.css';

function Header() {
  return (
    <div className="header">
      <h1>Max's Deep Learning Website</h1>
      <hr />
    </div>
  );
}
export default Header;
